document.addEventListener("DOMContentLoaded", () => {
  const stickyBtnBox = document.querySelector(".sticky_btn_box");
  const footer = document.querySelector("footer");
  const scrollBtn = document.querySelector(".sticky_btn");

  if (!stickyBtnBox || !footer) return;

  const baseBottom = 50; // 通常時の固定位置
  const stopMargin = 20; // footer上20pxで停止

  window.addEventListener("scroll", () => {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const windowH = window.innerHeight;
    const footerRect = footer.getBoundingClientRect();
    const footerTop = footerRect.top + scrollY;
    const stopPoint = footerTop - windowH + stopMargin;

    if (scrollY > 350 && scrollY < stopPoint) {
      stickyBtnBox.classList.add("show");
      stickyBtnBox.classList.remove("hide");
      stickyBtnBox.style.position = "fixed";
      stickyBtnBox.style.bottom = `${baseBottom}px`;
    } else if (scrollY >= stopPoint) {
      stickyBtnBox.style.position = "absolute";
      stickyBtnBox.style.bottom = `${footer.offsetHeight + stopMargin}px`;
    } else {
      stickyBtnBox.classList.remove("show");
      stickyBtnBox.classList.add("hide");
    }
  });

  // クリックでスムーズにトップへ戻る
  scrollBtn.addEventListener("click", (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});

$(function () {
  // スクロールイベントを監視
  $(window).on("scroll", function () {
    // 移動単位を算出1vwとする
    var offset = 0.01 * $(window).width();

    if ($(".keyword_box1").hasClass("is-show")) {
      /* .keyword1、2に対する処理 */
      const tmp1_top = $(".keyword_box1").children(".keyword1").css("top");
      const tmp1_left = $(".keyword_box1").children(".keyword1").css("left");
      const tmp1_bottom = $(".keyword_box1")
        .children(".keyword2")
        .css("bottom");
      const tmp1_right = $(".keyword_box1").children(".keyword2").css("right");
      //数値に変換
      const tmp1_top2 = parseInt(tmp1_top);
      const tmp1_left2 = parseInt(tmp1_left);
      const tmp1_bottom2 = parseInt(tmp1_bottom);
      const tmp1_right2 = parseInt(tmp1_right);
      // CSSを更新
      if (tmp1_top2 < 0) {
        if (tmp1_top2 + offset < 0) {
          var val1 = tmp1_top2 + offset;
        } else {
          var val1 = 0;
        }
        $(".keyword_box1")
          .find(".keyword1")
          .css({
            top: val1 + "px",
            left: val1 + "px",
          });
      }
      if (tmp1_bottom2 < 0) {
        if (tmp1_bottom2 + offset < 0) {
          var val2 = tmp1_bottom2 + offset;
        } else {
          var val2 = 0;
        }
        $(".keyword_box1")
          .find(".keyword2")
          .css({
            bottom: val2 + "px",
            right: val2 + "px",
          });
      }
    }
    if ($(".keyword_box2").hasClass("is-show")) {
      /* .keyword1、2に対する処理 */
      const tmp2_top = $(".keyword_box2").children(".keyword1").css("top");
      const tmp2_left = $(".keyword_box2").children(".keyword1").css("left");
      const tmp2_bottom = $(".keyword_box2")
        .children(".keyword2")
        .css("bottom");
      const tmp2_right = $(".keyword_box2").children(".keyword2").css("right");
      //数値に変換
      const tmp2_top2 = parseInt(tmp2_top);
      const tmp2_left2 = parseInt(tmp2_left);
      const tmp2_bottom2 = parseInt(tmp2_bottom);
      const tmp2_right2 = parseInt(tmp2_right);
      // CSSを更新
      if (tmp2_top2 < 0) {
        if (tmp2_top2 + offset < 0) {
          var val3 = tmp2_top2 + offset;
        } else {
          var val3 = 0;
        }
        $(".keyword_box2")
          .find(".keyword1")
          .css({
            top: val3 + "px",
            left: val3 + "px",
          });
      }
      if (tmp2_bottom2 < 0) {
        if (tmp2_bottom2 + offset < 0) {
          var val4 = tmp2_bottom2 + offset;
        } else {
          var val4 = 0;
        }
        $(".keyword_box2")
          .find(".keyword2")
          .css({
            bottom: val4 + "px",
            right: val4 + "px",
          });
      }
    }
  });
});
